module.exports = __webpack_public_path__ + "static/media/A1-R1-Recurso-codR3.cb5710ed.png";